<div class="poweredby-stellar-container">
  <div class="powered-by-stellar">
    <div class="poweredBy-text">Powered by</div>
    <div class="stellar-logo">
      <img
        src="assets/images/stellar/stellar.svg"
        alt="stellar-logo"
        loading="lazy"
      />
    </div>
  </div>
</div>
